import type { ResultsPageDataTransferObject } from '@mobi/api-types/racePage/types'
import MissingStartersException from '../Exceptions/MissingStartersException'
import type ObservableResultsPage from '../Model/Observables/ObservableResultsPage'
import FinisherBuilder from './FinisherBuilder'

export default {
  map(dto: ResultsPageDataTransferObject, model: ObservableResultsPage) {
    if (!dto || !dto.Finishers) throw new MissingStartersException('No finishers available')

    dto.Finishers.forEach(finisher => {
      model.addFinisher(FinisherBuilder.from(finisher.Type).build(finisher))
    })
  },
}
